import { useEffect, useState } from "react";

import { adminApi, type StorageOverview } from "../api";
import { StatusTile } from "../components/StatusTile";

export function Storage(): JSX.Element {
  const [data, setData] = useState<StorageOverview | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    adminApi
      .get<StorageOverview>("/api/v1/admin/storage")
      .then(setData)
      .catch((err) => setError(err instanceof Error ? err.message : String(err)));
  }, []);

  return (
    <div>
      <h2 className="page-title">📦 Storage</h2>
      <p className="page-subtitle">Placement + integrity — by tier and by copy state.</p>
      {error && <div className="error-banner">{error}</div>}
      {data && (
        <>
          <div className="status-grid">
            <StatusTile status={data.integrity} />
          </div>
          <div className="panel">
            <h3>By tier</h3>
            <table>
              <thead>
                <tr>
                  <th>Tier</th>
                  <th>Objects</th>
                  <th>Bytes</th>
                </tr>
              </thead>
              <tbody>
                {data.by_tier.map((t) => (
                  <tr key={t.tier}>
                    <td>{t.tier}</td>
                    <td>{t.object_count}</td>
                    <td>{t.bytes_total.toLocaleString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="panel">
            <h3>Copy states</h3>
            <table>
              <thead>
                <tr>
                  <th>State</th>
                  <th>Count</th>
                </tr>
              </thead>
              <tbody>
                {data.copy_states.map((c) => (
                  <tr key={c.state}>
                    <td>{c.state}</td>
                    <td>{c.count}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
}
